var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var pagerReducer = function (state, action) {
    switch (action.type) {
        case "SET_PAGE_SIZE":
            if (state.pageSize === action.payload) {
                return state;
            }
            return __assign(__assign({}, state), { pageSize: action.payload });
    }
    return state;
};
//# sourceMappingURL=use-pager-reducer.js.map